import styles from "./TechStack.module.css";
import {
  CPlusLogo,
  CSharpLogo,
  HtmlLogo,
  JavaLogo,
  JavascirptLogo,
  PythonLogo,
} from "../../../../../../assets/svgs";

const TechStack = ({ data, onChange }) => {
  const techIcons = {
    Javascript: <JavascirptLogo />,
    Python: <PythonLogo />,
    "C-Sharp": <CSharpLogo />,
    "C++": <CPlusLogo />,
    Java: <JavaLogo />,
    HTML: <HtmlLogo />,
  };
  return (
    <>
      <div className={styles.content_wrap}>
        <div className={styles.content}>
          <div className={styles.title}>Tech stack</div>
          <div className={styles.icon_group}>
            {data?.techStack?.map((key) => (
              <div>{techIcons[key]}</div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TechStack;
